import {createSlice} from "@reduxjs/toolkit";

const initialListingrulesState = {
  listLoading: false,
  actionsLoading: false,
  total_count: 0,
  entities: null,
  listingruleForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const listingrulesSlice = createSlice({
  name: "listingrules",
  initialState: initialListingrulesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getListingruleById
    listingruleFetched: (state, action) => {
      state.actionsLoading = false;
      state.listingruleForEdit = action.payload.listingruleForEdit;
      state.error = null;
    },
    // findListingrules
    listingrulesFetched: (state, action) => {
      const { total_count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.total_count = total_count;
    },
    // createListingrule
    listingruleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.listingrule);
    },
    // updateListingrule
    listingruleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.listingrule.id) {
          entity = {...entity, ...action.payload.listingrule};
        }
        return entity;
      });
    },
    // deleteListingrule
    listingruleDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteListingrules
    listingrulesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // listingrulesUpdateState
    listingrulesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
